/**
 * SGKC030A
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface SlidecalculationelementsInfoDto {

    /**
     * 算定諸元コード
     */
    slidecalculationelementsCode?: string;
    /**
     * 算定諸元項目名
     */
    slidecalculationelementsItemname?: string;
    /**
     * 算定諸元情報
     */
    slidecalculationelementsInfo?: string;
}

